import { render, staticRenderFns } from "./header.vue?vue&type=template&id=29e8c3c6&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style0 from "./header.vue?vue&type=style&index=0&id=29e8c3c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e8c3c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29e8c3c6')) {
      api.createRecord('29e8c3c6', component.options)
    } else {
      api.reload('29e8c3c6', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=29e8c3c6&scoped=true", function () {
      api.rerender('29e8c3c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header.vue"
export default component.exports